

<script>
export default class backgroundImage{
  constructor(_src, _Ystart, _decrementPerFrame, _sourceSidePxs, _imgLoadCounter) {
    //image holder
    this.backgroundImage = new Image();
    this.backgroundImage.onload = function (){
      _imgLoadCounter.imgsloaded++
    }
    this.backgroundImage.src = _src;
    //store starting y
    this.startingY = _Ystart
    // y position on the image to draw
    this.backgroundY = _Ystart;
    //how many px to move the image per 1/100s (mover from bottom to top)
    this.decrementPerFrame = _decrementPerFrame;
    //side dimension of the square chunk taken out of the background image to display on canvas
    this.sourceSidePxs = _sourceSidePxs;
  }
}
</script>

